import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import CardReasonStore from 'stores/CardReasonStore';
import ReasonsSelectField from 'components/pure/admin/ReasonsSelectField';

class ReasonSelectFieldContainer extends React.Component {
  static getStores() {
    return [CardReasonStore];
  }

  static getPropsFromStores() {
    const cardReasonStore = CardReasonStore.getState();
    return {
      values: cardReasonStore.cardReasons,
    };
  }

  render() {
    return <ReasonsSelectField {...this.props} />;
  }
}

export default connectToStores(ReasonSelectFieldContainer);
